import React from 'react';
import styled from 'styled-components';

interface Props {
  hash: string;
}

const Hash: React.FC<Props> = ({ hash }) => {
  return <StyledDiv>{hash}</StyledDiv>;
};

export default Hash;

const StyledDiv = styled.div`
  font-family: monospace;
  background-color: aliceblue;
  padding: 0.1em 0.5em 0 0.5em;
  border-radius: 4px;
  font-size: 0.6875rem;
`;
